<template>
    <div class="relative" @mouseenter="openDropdown" @mouseleave="closeDropdown">
        <div ref="dropdownButton" :class="buttonClass"
             class="focus:outline-none font-medium inline-flex items-center leading-tight">
            <slot name="button">Кнопка</slot>
        </div>
        <div ref="dropdownMenu" v-if="isOpen" class="absolute right-0 z-10 pt-2" @click="insideToggleEvent">
            <div class="relative border bg-white divide-y divide-gray-100 rounded-lg shadow overflow-hidden"
                 :class="[menuClass, widthClass]">
                <div v-if="withCloseButton" @click="closeDropdown" class="absolute top-2 end-2 z-2">
                    <IconX class="w-5 h-5 cursor-pointer stroke-black md:hover:stroke-navHoverColor transition"/>
                </div>
                <slot name="menu">Пусто</slot>
            </div>
        </div>
    </div>
</template>

<script>
import IconX from "@js/components/Icons/IconX.vue";
import {checkDocument} from "@js/helpers.ts";

export default {
    name: "ModalSelect",
    components: {IconX},
    props: {
        withCloseButton: {
            type: Boolean,
            default: false
        },
        buttonClass: {
            type: String,
            default: "border border-gray-500 bg-transparent text-black text-xs rounded px-3 py-1.5"
        },
        menuClass: {
            type: String,
            default: ""
        },
        widthClass: {
            type: String,
            require: false,
            default: "w-44",
        },
        closeOnClick: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            isOpen: false,
            scrollListener: null,
        };
    },
    methods: {
        openDropdown() {
            this.isOpen = true;
        },
        closeDropdown() {
            this.isOpen = false;
        },
        insideToggleEvent() {
            if (this.closeOnClick) {
                this.isOpen = false;
            }
        },
        onScroll() {
            if (this.isOpen) {
                this.isOpen = false;
            }
        },
    },
    mounted() {
        if (checkDocument()) {
            this.scrollListener = this.onScroll.bind(this);
            window.addEventListener("scroll", this.scrollListener, {passive: true});
        }
    },
    beforeUnmount() {
        if (checkDocument()) {
            window.removeEventListener("scroll", this.scrollListener);
        }
    },
};
</script>

<style scoped>
.z-2 {
    z-index: 2;
}
</style>
